module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "col-xs-12 main",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "row ls-charts book-appointment"
  }, [_c('h1', [_vm._v("Book Appointment")]), _vm._v(" "), (_vm.bookedAppointment) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "booking-card confirmation-card"
  }, [_c('div', {
    staticClass: "confirmation-header"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" "), _c('div', [_c('h2', [_vm._v("Appointment reserved")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.bookedCampaign.owner_name))]), _vm._v(" "), _c('span', {
    staticClass: "muted"
  }, [_vm._v("/")]), _vm._v(" " + _vm._s(_vm.bookedCampaign.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "expiry-warning"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-half"
  }), _vm._v(" "), _c('span', [_vm._v("Send this appointment within "), _c('strong', [_vm._v(_vm._s(_vm.bookedAppointment.blocked_period) + " minutes")]), _vm._v(" or it will expire.")])]), _vm._v(" "), _c('div', {
    staticClass: "appointment-id"
  }, [_c('span', {
    staticClass: "field-label"
  }, [_vm._v("Appointment ID")]), _vm._v(" "), _c('div', {
    staticClass: "appointment-id-value"
  }, [_c('code', [_vm._v(_vm._s(_vm.bookedAppointment.id))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm",
    class: _vm.copyFeedback ? 'btn-success' : 'btn-info',
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.copyAppointmentId
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.copyFeedback ? 'fa-check' : 'fa-copy'
  }), _vm._v(" " + _vm._s(_vm.copyFeedback ? 'Copied!' : 'Copy') + "\n              ")])])]), _vm._v(" "), _c('dl', {
    staticClass: "appointment-details"
  }, [_c('div', [_c('dt', [_vm._v("When")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.bookedAppointmentStartTime))])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("Type")]), _vm._v(" "), _c('dd', [_c('i', {
    staticClass: "fa fa-fw",
    class: [_vm.appointmentType(_vm.bookedAppointment.appointment_type).icon, 'type-color-' + _vm.bookedAppointment.appointment_type]
  }), _vm._v("\n                " + _vm._s(_vm.appointmentType(_vm.bookedAppointment.appointment_type).label) + "\n              ")])]), _vm._v(" "), (_vm.bookedAppointment.appointment_type == 'in-person-at-office') ? _c('div', [_c('dt', [_vm._v("Office address")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.bookedAppointment.appointment_location))])]) : _vm._e(), _vm._v(" "), _c('div', [_c('dt', [_vm._v("Company")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.bookedAppointment.agent.agency))])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("Agent")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.bookedAppointment.agent.name))])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("Email")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.bookedAppointment.agent.email
    }
  }, [_vm._v(_vm._s(_vm.bookedAppointment.agent.email))])])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("Phone")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.bookedAppointment.agent.phone))])])]), _vm._v(" "), _c('div', {
    staticClass: "confirmation-actions"
  }, [_c('button', {
    staticClass: "btn btn-default cancel-button",
    attrs: {
      "type": "button",
      "disabled": _vm.cancellingAppointment
    },
    on: {
      "click": _vm.cancelAppointment
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.cancellingAppointment ? 'fa-spinner fa-spin' : 'fa-times'
  }), _vm._v(" Cancel & Back\n            ")]), _vm._v(" "), (_vm.appointmentIdCopied) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.restart
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-plus-o"
  }), _vm._v(" New Appointment\n            ")]) : _c('span', {
    staticClass: "muted"
  }, [_vm._v("Copy the appointment ID to start a new one.")])])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "booking-card search-card"
  }, [_c('FormulateForm', {
    staticClass: "search-form",
    on: {
      "submit": _vm.searchSlots
    }
  }, [_c('FormulateInput', {
    attrs: {
      "name": "zipcode",
      "type": "text",
      "label": "Zip code",
      "placeholder": "e.g. 33101",
      "maxlength": "5",
      "error": _vm.findSlotsErrors.zipcode
    },
    model: {
      value: (_vm.zipcode),
      callback: function($$v) {
        _vm.zipcode = $$v
      },
      expression: "zipcode"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "name": "desired_date",
      "type": "date",
      "label": "Starting from",
      "error": _vm.findSlotsErrors.desired_date
    },
    model: {
      value: (_vm.desired_date),
      callback: function($$v) {
        _vm.desired_date = $$v
      },
      expression: "desired_date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "formulate-input search-action"
  }, [_c('span', {
    staticClass: "formulate-input-label",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.loadingSlots
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.loadingSlots ? 'fa-spinner fa-spin' : 'fa-search'
  }), _vm._v(" Find Slots\n              ")])])], 1), _vm._v(" "), (_vm.findSlotsErrors.non_field_errors) ? _c('p', {
    staticClass: "text-danger form-error"
  }, [_vm._v(_vm._s(_vm.findSlotsErrors.non_field_errors))]) : _vm._e()], 1), _vm._v(" "), (_vm.bookingError) ? _c('div', {
    staticClass: "alert alert-danger booking-error"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.bookingError = null
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" " + _vm._s(_vm.bookingError) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.loadingSlots) ? _c('div', {
    staticClass: "booking-card empty-state"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }), _vm._v(" "), _c('p', [_vm._v("Looking for available slots…")])]) : (!_vm.lastRequest) ? _c('div', {
    staticClass: "booking-card empty-state"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" "), _c('p', {
    staticClass: "empty-state-title"
  }, [_vm._v("Find an appointment")]), _vm._v(" "), _c('p', [_vm._v("Enter a zip code to see the available slots across all your campaigns.")])]) : (!_vm.campaignSlots.length) ? _c('div', {
    staticClass: "booking-card empty-state"
  }, [_c('i', {
    staticClass: "fa fa-calendar-times-o"
  }), _vm._v(" "), _c('p', {
    staticClass: "empty-state-title"
  }, [_vm._v("No slots available")]), _vm._v(" "), _c('p', [_vm._v("No licensed agents are available in " + _vm._s(_vm.lastRequest.zipcode) + " for the selected dates.")])]) : _c('div', {
    staticClass: "results"
  }, [_c('div', {
    staticClass: "results-header"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.campaignSlots.length))]), _vm._v(" " + _vm._s(_vm.campaignSlots.length === 1 ? 'campaign' : 'campaigns') + "\n              with availability in "), _c('strong', [_vm._v(_vm._s(_vm.lastRequest.zipcode))])]), _vm._v(" "), _c('span', {
    staticClass: "results-timezone"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Times shown in "), _c('strong', [_vm._v(_vm._s(_vm.timezoneLabel))])])]), _vm._v(" "), _vm._l((_vm.campaignSlots), function(entry) {
    return _c('div', {
      key: entry.campaign.id,
      staticClass: "campaign-card",
      class: {
        'is-expanded': _vm.isExpanded(entry), 'has-selection': _vm.isCampaignSelected(entry)
      }
    }, [_c('button', {
      staticClass: "campaign-header",
      attrs: {
        "type": "button",
        "aria-expanded": _vm.isExpanded(entry) ? 'true' : 'false'
      },
      on: {
        "click": function($event) {
          return _vm.toggleCampaign(entry)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-chevron-right campaign-chevron"
    }), _vm._v(" "), _c('span', {
      staticClass: "campaign-title"
    }, [_c('span', {
      staticClass: "campaign-owner"
    }, [_vm._v(_vm._s(entry.campaign.owner_name))]), _vm._v(" "), _c('span', {
      staticClass: "campaign-separator"
    }, [_vm._v("/")]), _vm._v(" "), _c('span', {
      staticClass: "campaign-name"
    }, [_vm._v(_vm._s(entry.campaign.name))])]), _vm._v(" "), _c('span', {
      staticClass: "campaign-types"
    }, _vm._l((entry.appointmentTypes), function(type) {
      return _c('i', {
        key: type,
        staticClass: "fa fa-fw",
        class: [_vm.appointmentType(type).icon, 'type-color-' + type],
        attrs: {
          "title": _vm.appointmentType(type).label
        }
      })
    }), 0), _vm._v(" "), _c('span', {
      staticClass: "campaign-next"
    }, [_c('span', {
      staticClass: "field-label"
    }, [_vm._v("Next available")]), _vm._v("\n                " + _vm._s(_vm.nextSlotLabel(entry.nextSlot)) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "campaign-count"
    }, [_vm._v(_vm._s(entry.count) + " " + _vm._s(entry.count === 1 ? 'slot' : 'slots'))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExpanded(entry)),
        expression: "isExpanded(entry)"
      }],
      staticClass: "campaign-body"
    }, _vm._l((entry.days), function(day) {
      return _c('div', {
        key: day.key,
        staticClass: "slot-day"
      }, [_c('div', {
        staticClass: "slot-day-label"
      }, [_c('span', {
        staticClass: "slot-day-weekday"
      }, [_vm._v(_vm._s(day.weekday))]), _vm._v(" "), _c('span', {
        staticClass: "slot-day-date"
      }, [_vm._v(_vm._s(day.date))])]), _vm._v(" "), _c('div', {
        staticClass: "slot-day-slots"
      }, _vm._l((day.blocks), function(block) {
        return _c('div', {
          key: block[0].start_timestamp,
          staticClass: "slot-block"
        }, _vm._l((block), function(slot) {
          return _c('div', {
            key: slot.start_timestamp,
            staticClass: "slot-card",
            class: {
              'is-selected': _vm.isSlotSelected(slot)
            }
          }, [_c('div', {
            staticClass: "slot-time"
          }, [_vm._v(_vm._s(_vm.timeLabel(slot)))]), _vm._v(" "), _c('div', {
            staticClass: "slot-options"
          }, _vm._l((slot.appointment_types), function(option, index) {
            return _c('button', {
              key: index,
              staticClass: "slot-option",
              class: ['slot-option-' + option.appointment_type, {
                'is-selected': _vm.isOptionSelected(option)
              }],
              attrs: {
                "type": "button",
                "title": _vm.optionTitle(option)
              },
              on: {
                "click": function($event) {
                  return _vm.selectOption(entry, slot, option)
                }
              }
            }, [_c('i', {
              staticClass: "fa",
              class: _vm.appointmentType(option.appointment_type).icon
            }), _vm._v("\n                          " + _vm._s(option.location || _vm.appointmentType(option.appointment_type).shortLabel) + "\n                        ")])
          }), 0)])
        }), 0)
      }), 0)])
    }), 0)])
  }), _vm._v(" "), (_vm.selection) ? _c('div', {
    staticClass: "selection-bar"
  }, [_c('div', {
    staticClass: "selection-summary"
  }, [_c('span', {
    staticClass: "selection-icon",
    class: 'type-background-' + _vm.selection.option.appointment_type
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.appointmentType(_vm.selection.option.appointment_type).icon
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "selection-title"
  }, [_vm._v(_vm._s(_vm.optionTitle(_vm.selection.option)))]), _vm._v(" "), _c('div', {
    staticClass: "selection-subtitle"
  }, [_vm._v(_vm._s(_vm.selectionTimeLabel) + " · " + _vm._s(_vm.selection.campaign.owner_name) + " / " + _vm._s(_vm.selection.campaign.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "selection-actions"
  }, [_c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "button",
      "disabled": _vm.confirmingSelection
    },
    on: {
      "click": function($event) {
        _vm.selection = null
      }
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.confirmingSelection
    },
    on: {
      "click": _vm.bookAppointment
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.confirmingSelection ? 'fa-spinner fa-spin' : 'fa-check'
  }), _vm._v(" Confirm Selection\n              ")])])]) : _vm._e()], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-658aa75e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/BookAppointment.vue
// module id = 675
// module chunks = 0